/** Leitura client-side de claims do JWT — sem validar assinatura (isso é do back). */

interface JwtPayload {
    exp?: number;
}

/** Decodifica o payload (2ª parte) de um JWT em base64url. */
function decodePayload(token: string): JwtPayload | null {
    try {
        const part = token.split(".")[1];
        if (!part) return null;

        const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(atob(base64)) as JwtPayload;
    } catch {
        return null;
    }
}

/**
 * true se o access token expira dentro de `skewSeconds` (ou já expirou).
 * Usado para o refresh proativo: renova ANTES de expirar, mantendo o
 * header Authorization sempre válido e evitando 401 nas rotas opcionais.
 */
export function isTokenExpiring(token: string, skewSeconds = 30): boolean {
    const payload = decodePayload(token);
    if (!payload?.exp) return false;

    const nowSeconds = Date.now() / 1000;
    return payload.exp - nowSeconds <= skewSeconds;
}
